module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personal-admin-program-page"
  }, [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_pp_title')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.userTitle))])], 1), _vm._v(" "), _c('div', {
    staticClass: "wod-navigation"
  }, [_c('div', {
    staticClass: "wod-arrow",
    on: {
      "click": function($event) {
        return _vm.changeWeek(-1)
      }
    }
  }, [_vm._v("◀")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentWeek))]), _vm._v(" "), _c('div', {
    staticClass: "wod-arrow",
    on: {
      "click": function($event) {
        return _vm.changeWeek(1)
      }
    }
  }, [_vm._v("▶")])]), _vm._v(" "), _c('div', {
    staticClass: "wod-container"
  }, _vm._l(([0, 1, 2, 3, 4, 5, 6]), function(item) {
    return _c('div', {
      staticClass: "wod-item"
    }, [(!_vm.isEnableDate(_vm.week[item].date)) ? _c('div', [_vm._v(_vm._s(_vm.week[item].date) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.isEnableDate(_vm.week[item].date)) ? _c('div', [_vm._v(_vm._s(_vm.getDayOfWeek(_vm.week[item].date)))]) : _vm._e(), _vm._v(" "), (!_vm.isEnableDate(_vm.week[item].date)) ? _c('div', {
      staticClass: "wod-content"
    }, [_c('div', [_vm._v(_vm._s(_vm.locale.t('label_not_include_in_program')))])]) : _vm._e(), _vm._v(" "), (_vm.isEnableDate(_vm.week[item].date)) ? _c('div', [_vm._v(_vm._s(_vm.week[item].date))]) : _vm._e(), _vm._v(" "), (_vm.isEnableDate(_vm.week[item].date)) ? _c('div', [_vm._v(_vm._s(_vm.getDayOfWeek(_vm.week[item].date)))]) : _vm._e(), _vm._v(" "), (_vm.isEnableDate(_vm.week[item].date)) ? _c('div', {
      staticClass: "new-button wod-font-copy",
      on: {
        "click": function($event) {
          return _vm.copyTrainingForDates(_vm.week[item])
        }
      }
    }, [_c('i', {
      staticClass: "ti-save"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_copy_rd')))]) : _vm._e(), _vm._v(" "), (_vm.isEnableDate(_vm.week[item].date)) ? _c('button', {
      staticClass: "wod-plus-button",
      on: {
        "click": function($event) {
          return _vm.showDefinitionAdd(_vm.week[item])
        }
      }
    }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getGroupedDayDetails(_vm.week[item].details)), function(group) {
      return (_vm.isEnableDate(_vm.week[item].date)) ? _c('div', {
        key: group.key,
        class: group.isSuperSet ? 'wod-superset-group' : 'wod-single-group'
      }, [(group.isSuperSet) ? _c('div', {
        staticClass: "wod-superset-title"
      }, [_vm._v(_vm._s(group.superSetName))]) : _vm._e(), _vm._v(" "), _vm._l((group.items), function(detailsItem, detailsIndex) {
        return _c('div', {
          key: (detailsItem.id || detailsIndex) + '-day-item',
          staticClass: "wod-content-row",
          class: {
            'is-drag-source': _vm.dragDayDate === _vm.week[item].date && _vm.dragItemId === detailsItem.id,
            'is-drop-before': _vm.isDropZoneActive(_vm.week[item], detailsItem, 'before'),
            'is-drop-after': _vm.isDropZoneActive(_vm.week[item], detailsItem, 'after')
          },
          attrs: {
            "draggable": "true"
          },
          on: {
            "dragstart": function($event) {
              return _vm.onDayTrainingDragStart(_vm.week[item], detailsItem, $event)
            },
            "dragover": function($event) {
              return _vm.onDayTrainingDragOver(_vm.week[item], detailsItem, $event)
            },
            "drop": function($event) {
              return _vm.onDayTrainingDrop(_vm.week[item], detailsItem, $event)
            },
            "dragend": function($event) {
              return _vm.onDayTrainingDragEnd()
            }
          }
        }, [_c('div', {
          staticClass: "wod-content wod-content--draggable"
        }, [_c('div', [(_vm.getTrainingThumb(detailsItem)) ? _c('img', {
          staticClass: "cropped1 user-avatar-sm",
          attrs: {
            "src": _vm.getTrainingThumb(detailsItem),
            "draggable": "false"
          }
        }) : _c('div', {
          staticClass: "wod-thumb-fallback"
        }, [_c('i', {
          staticClass: "ti-control-play"
        })])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getName(detailsItem)) + "\n                "), _c('span', {
          staticClass: "new-button wod-order-button",
          class: {
            'is-disabled': !_vm.canMoveDayTraining(_vm.week[item], detailsItem, -1)
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.moveDayTrainingByStep(_vm.week[item], detailsItem, -1)
            }
          }
        }, [_c('i', {
          staticClass: "ti-angle-up"
        })]), _vm._v(" "), _c('span', {
          staticClass: "new-button wod-order-button",
          class: {
            'is-disabled': !_vm.canMoveDayTraining(_vm.week[item], detailsItem, 1)
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.moveDayTrainingByStep(_vm.week[item], detailsItem, 1)
            }
          }
        }, [_c('i', {
          staticClass: "ti-angle-down"
        })]), _vm._v(" "), _c('span', {
          staticClass: "new-button"
        }, [_c('i', {
          staticClass: "ti-pencil",
          on: {
            "click": function($event) {
              return _vm.editDefinitionData(detailsItem)
            }
          }
        })]), _vm._v(" "), _c('span', {
          staticClass: "new-button",
          on: {
            "click": function($event) {
              return _vm.deleteTrainingOfTheDay(detailsItem)
            }
          }
        }, [_c('i', {
          staticClass: "ti-trash icon-danger"
        })])]), _vm._v(" "), (group.items.length > 1 && detailsIndex < group.items.length - 1) ? _c('p', {
          staticClass: "wod-separator"
        }) : _vm._e()])])
      })], 2) : _vm._e()
    }), _vm._v(" "), (_vm.isEnableDate(_vm.week[item].date) && _vm.week[item].details.length > 0 && _vm.isDropZoneVisible(_vm.week[item]) && _vm.getLastDayTraining(_vm.week[item]) != null) ? _c('div', {
      staticClass: "wod-drop-zone wod-drop-zone--end",
      class: {
        'is-active': _vm.isDropZoneActive(_vm.week[item], _vm.getLastDayTraining(_vm.week[item]), 'after')
      },
      on: {
        "dragover": function($event) {
          _vm.onDayTrainingDragOver(_vm.week[item], _vm.getLastDayTraining(_vm.week[item]), $event)
        },
        "drop": function($event) {
          _vm.onDayTrainingDrop(_vm.week[item], _vm.getLastDayTraining(_vm.week[item]), $event)
        }
      }
    }, [_c('span', {
      staticClass: "wod-drop-zone__label"
    }, [_vm._v(_vm._s(_vm.locale.t('label_drop_here')))])]) : _vm._e(), _vm._v(" "), (_vm.isEnableDate(_vm.week[item].date) && _vm.isDayDirty(_vm.week[item])) ? _c('div', {
      staticClass: "new-button wod-save-order-button",
      class: {
        'is-loading': _vm.isSavingDayOrder[_vm.week[item].date]
      },
      on: {
        "click": function($event) {
          return _vm.saveDayOrder(_vm.week[item])
        }
      }
    }, [_c('i', {
      staticClass: "ti-save"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_save_order')) + "\n        ")]) : _vm._e()], 2)
  }), 0), _vm._v(" "), _c('add-training-of-the-day-personal', {
    attrs: {
      "show": _vm.showAddDefinition,
      "date": _vm.addDefinitionDate,
      "type": 'PERSONAL',
      "data": _vm.definitionDataToEdit,
      "programId": _vm.id
    }
  }), _vm._v(" "), _c('choose-training-definition-modal', {
    attrs: {
      "show": _vm.showChooseDefinition,
      "date": _vm.chooseDefinitionDate,
      "type": 'PERSONAL',
      "personalProgramId": _vm.id
    }
  }), _vm._v(" "), _c('copy-training-for-dates', {
    attrs: {
      "show": _vm.copyTrainingForDate,
      "item": _vm.copyTrainingForDateItem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dd2aa99!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Personal/PersonalAdminProgram.vue
// module id = 743
// module chunks = 0